// Generated by scripts/build-ui-icons.mjs.
export { Star as default } from "../ui/glyphs-7";
